import { createGlobalStyle } from 'styled-components';
import { fontMap } from './brand/specs';
import CarbonVars from './CarbonVars';
import { carbonCssVariables } from './tools';

const GlobalStyles = createGlobalStyle`
  /* stylelint-disable */
  /* Minimal reset */
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    text-decoration: none;
  }

  *::before,
  *::after {
    box-sizing: inherit;
  }
  @font-face {
    font-family: ${fontMap.base.name};
    src: url(${fontMap.base.font});
    font-display: swap;
  }
  @font-face {
    font-family: ${fontMap.baseLight.name};
    src: url(${fontMap.baseLight.font});
    font-display: swap;
  }
  @font-face {
    font-family: ${fontMap.baseMedium.name};
    src: url(${fontMap.baseMedium.font});
    font-weight: 500;
    font-display: swap;
  }
  @font-face {
    font-family: ${fontMap.heading.name};
    src: url(${fontMap.heading.font});
    font-display: swap;
  }
  @font-face {
    font-family: ${fontMap.castrol.name};
    src: url(${fontMap.castrol.font});
    font-display: swap;
  }


  html, body {
    font-family: ${fontMap.base.name}, Arial, sans-serif;
    font-size: 100%; /* 16px base font */
  }

  body {
    overflow-x: hidden;
  }

  /* Screen reader only */
   & .sr {
    height: 0;
    overflow: hidden;
    visibility: hidden;
    width: 0;
  }
  /* stylelint-enable */

  /* To support legacy components */
  :root {
    --type-3: 1.875rem/2.25rem;

    /* Font Families */
    --font-ibm: ${fontMap.base.name}, Arial, sans-serif;

    /* Ease functions */
    --ease-inOut: cubic-bezier(0.645, 0.045, 0.355, 1);

    ${carbonCssVariables(CarbonVars)}
  }
`;

export default GlobalStyles;
